export const MENU_LOGIN = '/login'
export const MENU_HOME = '/dashboard'
export const PIM_NEW_RESIGN = '/employee/monthly'
export const EMP_MONTHLY_NEW = '/employee/monthly/new'
export const EMP_MONTHLY_RESIGNS = '/employee/monthly/resigns'
export const EMP_MONTHLY_APPOINT = '/employee/monthly/appoint'
export const EMP_MONTHLY_HBD = '/employee/monthly/HBD'
// export const EMP_CONTRACT = '/employee/contract'
export const EMP_CONTRACT_ALL_EMP = '/employee/contract/all-emp'
export const EMP_CONTRACT_NEW_EMP = '/employee/contract/new-emp'
export const EMP_CONTRACT_INFO = '/employee/contract/info'

export const EMP_CONTRACT_FULLTIME_PDF = '/employee/contract/fulltime-pdf'
export const EMP_CONTRACT_SECRET_PDF = '/employee/contract/secret-pdf'
export const EMP_CONTRACT_PDPA_PDF = '/employee/contract/pdpa-pdf'
export const EMP_CONTRACT_COMPENSATION_SLIP_PDF =
  '/employee/contract/compensation-slip-pdf'

export const PIM_EMP = '/employee/pim'
// export const PIM_TRANSFER = '/employee/transfer'
export const PIM_CREATE = '/employee/pim/create'

export const EMP_CHECK_LIST_NEW = '/employee/check-list/new'
export const EMP_CHECK_LIST_RESIGN = '/employee/check-list/resigns'
export const EMP_CHECK_LIST_RESIGN_ADMIN = EMP_CHECK_LIST_RESIGN + '/Admin'
export const EMP_CHECK_LIST_RESIGN_PD = EMP_CHECK_LIST_RESIGN + '/PD'
export const EMP_CHECK_LIST_RESIGN_IT = EMP_CHECK_LIST_RESIGN + '/IT'
export const EMP_CHECK_LIST_DETAIL = '/employee/check-list/check-list-detail'
export const EMP_CHECK_LIST_DETAIL_ST_1 = EMP_CHECK_LIST_NEW + '/stap-0'
export const EMP_CHECK_LIST_DETAIL_ST_2 = EMP_CHECK_LIST_NEW + '/stap-1'
export const EMP_CHECK_LIST_DETAIL_ST_3 = EMP_CHECK_LIST_NEW + '/stap-2'
export const EMP_CHECK_LIST_DETAIL_ST_4 = EMP_CHECK_LIST_NEW + '/stap-3'
export const EMP_CHECK_LIST_DETAIL_ST_5 = EMP_CHECK_LIST_NEW + '/stap-4'

export const EMP_PVD = '/employee/pvd'

export const EMP_TRANSFER = '/employee/transfer'
export const EMP_TRANSFER_PROMOTE = '/employee/transfer/promotion'
export const EMP_TRANSFER_DETAIL = '/employee/transfer/detail'
export const EMP_TRANSFER_DETAIL_HISTORY = '/employee/transfer/history/detail'
export const EMP_TRANSFER_ORG = '/employee/transfer/transfer-org'
export const EMP_TRANSFER_ORG_DETAIL = '/employee/detail/transfer-org'
export const EMP_PVD_HISTORY = '/employee/transfer/history'

export const EMP_EJIP = '/employee/e-jip'
export const EMP_EJIP_DETAIL = '/employee/e-jip/detail'
export const EMP_EJIP_DETAIL3 = '/employee/e-jip/e-jip-3'

export const EMP_EJIP_ALLMEMBER = '/employee/e-jip/e-jip-all-member'
export const EMP_EJIP_MEMBERBY_ROUND = '/employee/e-jip/e-jip-member-round'
// export const PIM_CHECK_LIST = '/employee/check-list'

export const PIM_EMP_INFO = '/employee/pim/employee-info'
export const INFO_HIST = '/employee/pim/employee-info/historical'
export const INFO_PERSONAL = '/employee/pim/employee-info/personal'
export const INFO_EMER = '/employee/pim/employee-info/emergency'
export const INFO_EDUC = '/employee/pim/employee-info/education'
export const INFO_WORK = '/employee/pim/employee-info/work-history'
export const INFO_CRIMINAL = '/employee/pim/employee-info/criminal-record'
export const INFO_DOCUMENT = '/employee/pim/employee-info/document'
export const INFO_CERTIFICATE = '/employee/pim/employee-info/certificate'
export const INFO_RESIGNS = '/employee/pim/employee-info/resigns'

export const PIM_EMP_WELFARE = '/employee/pim/welfare'
export const PIM_EMP_WELFARE_PVD = '/employee/pim/welfare/pvd'
export const PIM_EMP_WELFARE_EJIP = '/employee/pim/welfare/e-jip'
export const PIM_EMP_WELFARE_LOAN_HOME = '/employee/pim/welfare/loan-home'
export const PIM_EMP_WELFARE_BEM = '/employee/pim/welfare/bem'
export const PIM_EMP_WELFARE_CAR = '/employee/pim/welfare/car'
export const PIM_EMP_WELFARE_CAR_PARK = '/employee/pim/welfare/car-park'
export const PIM_EMP_WELFARE_FIT_FIRM = '/employee/pim/welfare/fit-firm'
export const PIM_EMP_WELFARE_LEAVE = '/employee/pim/welfare/leave'

export const PIM_EMP_PROPERTY = '/employee/pim/property-info'
export const PIM_EMP_PROPERTY_ASS = '/employee/pim/property-info/assets'
export const PIM_EMP_PERSONAL_PROFILE = '/employee/pim/personal-profile'

export const PIM_ORG_CHART = '/setting/organization/chart'
export const PIM_ORG_EXPAND = '/setting/organization/expand'

export const PIM_ORG_CHART_SET = '/setting/organization/chart-setting' //Chart

export const PIM_ATTENDANCE = '/attendance'
export const PIM_TRAIN = '/training'
export const PIM_EVA = '/evaluation'
export const PIM_RECRUI = '/recruitment'
export const PIM_PDREQ = '/pd-request'

// Organization Chart
export const PIM_SETTING = '/pim/setting'

export const PAGE_SETTING = '/setting/organization'
export const PIM_ORG_DIVISION = '/setting/organization/division'
export const PIM_ORG_FACTION = '/setting/organization/faction'
export const PIM_ORG_DEPARTMENT = '/setting/organization/department'
export const PIM_ORG_TEAM = '/setting/organization/team'
export const PIM_ORG_POSITION = '/setting/organization/position'

export const PAGE_ORG_RIGHT = '/setting/organization-right'
export const PAGE_ORG_RIGHT_DETAIL = '/setting/organization-right/detail'
export const PAGE_ORG_RIGHT_ADD = '/setting/organization-right/add'
export const PAGE_MENU_RIGHT = '/setting/organization-menu'

export const PAGE_HOLIDAY = '/setting/holiday'
export const PAGE_CONTRACTS = '/setting/contracts'
export const PAGE_ASSET_IT = '/setting/assetit'

export const PAGE_MYPROFILE = '/my-profile/job-position'
export const PAGE_MYPROFILE_PRESONAL = '/my-profile/personal'
export const PAGE_MYPROFILE_EMERGENCY = '/my-profile/Emergency-Contact'
export const PAGE_MYPROFILE_EDUCATION = '/my-profile/Education-History'
export const PAGE_MYPROFILE_WORKHISTORY = '/my-profile/Work-History'
export const PAGE_MYPROFILE_DOCUMENT = '/my-profile/Document'
export const PAGE_MYPROFILE_CERTIFICATE = '/my-profile/certificate'

export const PAGE_REPORT = '/report'
export const PAGE_REPORT_NEW = '/report/new'
export const PAGE_REPORT_RESIGN = '/report/resign'
export const PAGE_REPORT_BIRTHDAY = '/report/birthday'
export const PAGE_REPORT_APPOINT = '/report/appoint'
export const PAGE_REPORT_LOAN_HOME = '/report/loan-home'
export const PAGE_REPORT_GUSTO = '/report/gusto'

//Income and deductions
export const PAGE_INCOME = '/income'
export const PAGE_INCOME_IN = '/income/in'
export const PAGE_INCOME_IN_NEW = '/income/in/new'
export const PAGE_INCOME_OUT = '/income/deductions'
export const PAGE_INCOME_KYS = '/income/kys'
export const PAGE_INCOME_KYS_DETAIL = '/income/kys/detail'
export const PAGE_INCOME_DIF = '/income/home-loan'
export const PAGE_INCOME_DIF_DETAIL = '/income/home-loan/detail'

export const PAGE_INCOME_SHIFT = '/income/shift'
export const PAGE_INCOME_SHIFT_DETAIL = '/income/shift/detail'

export const PAGE_INCOME_DILIG = '/income/diligence'
export const PAGE_INCOME_DILIG_DETAIL = '/income/diligence/detail'

export const PAGE_SETTING_CERT = '/setting/certificate'

export const PAGE_REPORT_ATTENDANCE = '/report/attendance'
export const PAGE_REPORT_ATTENDANCE_V2 = '/report/attendance-v2'
export const PAGE_REPORT_LEAVE = '/report/leave'

export const PAGE_INCOME_CERTIFICATE = '/income/certificate'
export const PAGE_INCOME_CERTIFICATE_DETAIL = '/report/certificate/detail'

export const PAGE_INCOME_PAYROLL = '/income/payroll'
export const PAGE_INCOME_PAYROLL_HISTORY = '/income/payroll/history'
export const PAGE_INCOME_PAYROLL_PRINT = '/income/payroll-print'
export const PAGE_INCOME_PAYROLL_PRINT_DETAIL = '/income/payroll-print/detail'

export const PAGE_SETTING_COST_CENTER = '/setting/cost-center'
export const PAGE_SETTING_LEAVE = '/setting/leave'
// export const PAGE_SETTING_LEAVE_V2 = '/setting/leave/v2'
export const PAGE_SETTING_LEAVE_ASSIGN = '/setting/leave/assign'
export const PAGE_SETTING_LEAVE_ADD = '/setting/leave/add'

export const PAGE_SETTING_LEAVE_MAS = '/setting/leave'
export const PAGE_SETTING_LEAVE_ORG = '/setting/leave/org'

export const PAGE_REPORT_EDUCATION = '/report/education'

export const PAGE_SETTING_LOCATION = '/setting/location'
export const PAGE_SETTING_LOCATION_DETAIL = '/setting/location/detail'
export const PAGE_SETTING_LOCATION_ASSIGN = '/setting/location/org'
export const PAGE_SETTING_LOCATION_ORG_DETAIL = '/setting/location/org/detail'
export const PAGE_SETTING_NOTI = '/setting/noti'
export const PAGE_SETTING_NOTI_ADD = '/setting/noti/add'
export const PAGE_SETTING_NOTI_VIEW = '/setting/noti/view'
